import type {
  AncillaryPurchasedItem,
  NapiV2PurchasedItem
} from "@app/types/napi-v2-purchase-types";
import { isAncillaryPurchasedItem } from "@app/types/napi-v2-purchase-types";

export function getAncillaryPurchasedItems(
  purchase_items: NapiV2PurchasedItem[]
): AncillaryPurchasedItem[] {
  return purchase_items.filter(isAncillaryPurchasedItem);
}
